import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppConstants {
    public TEST: string = "testval";
    public TEST2: string = "testval2";
    public firstObj: number = 0;
}